import * as api from '../api'

// Action creator
export const createQuestionBox = (questionBox, match) => async (dispatch, getState) => {
    try {

        const newQuestionBox = questionBox
        newQuestionBox.creation = Date.now()
        newQuestionBox.idMatch = match.idMatch ? match.idMatch : match.idActu
        if(newQuestionBox.timer === undefined)
            newQuestionBox.timer = !match.timer ? 0 : match.timer === 0 ? (Math.floor(match.timer/60))*60 : (Math.floor((match.timer + 60)/60))*60
        if(newQuestionBox.period === undefined)
            newQuestionBox.period = match.period ? match.period : 0

        const { data } = await api.createQuestionBox(newQuestionBox)

        console.log('created question box', data);

        return data;

        //dispatch( { type : CREATE_NOTATION, payload: data })
    } catch(error){
        console.log(error)
        throw error;
    }
}

export const updateQuestionBox = (questionBoxDetail, id) => async (dispatch, getState) => {
    try {
        const { data } = await api.updateQuestionBox(id, questionBoxDetail)

        console.log('updated question box', data);

        return data;

        //dispatch({ type : UPDATE_NOTATION, payload: data})
    } catch(error){
        console.log(error)
        throw error;
    }
}

export const deleteQuestionBox = (id) => async (dispatch) => {
    try {
        await api.deleteQuestionBox(id)

        //dispatch({ type : DELETE_NOTATION, payload: id})
    }catch(error){
        console.log(error)
    }
}